export const FREE_TRIAL_DAYS = 7; 